module.exports = __webpack_public_path__ + "img/10-1.08de2cab.jpg";